import React from 'react';

var _path;

var SvgAppExtensionMinor = function SvgAppExtensionMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17h-4.5a1.5 1.5 0 0 1-1.5-1.5v-4.5h6v6zm8-6v4.5a1.5 1.5 0 0 1-1.5 1.5h-4.5v-6h6zm-8-2h-6v-4.5a1.5 1.5 0 0 1 1.5-1.5h4.5v6zm10-7v5c0 .55-.45 1-1 1s-1-.45-1-1v-2.58l-4.29 4.29c-.2.19-.45.29-.71.29-.26 0-.51-.1-.71-.29-.39-.39-.39-1.03 0-1.42l4.29-4.29h-2.58c-.55 0-1-.45-1-1s.45-1 1-1h5c.08 0 .17.01.25.04.05 0 .09.02.14.04.12.05.23.12.32.21s.16.2.21.32c.02.05.04.09.04.14.03.08.04.17.04.25z"
  })));
};

export { SvgAppExtensionMinor as S };
